import React, { useEffect } from 'react';
import Navbar from '../../components/layout/Navbar';
import Footer from '../../components/layout/Footer';
import ScienceBackground from '../../components/layout/ScienceBackground';
import { FaFileSignature, FaUserGraduate, FaMoneyBillWave, FaVideo, FaBan, FaBalanceScale } from 'react-icons/fa';

const TermsOfService = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="font-sans bg-slate-50 min-h-screen text-slate-800 overflow-x-hidden selection:bg-orange-500 selection:text-white relative flex flex-col pt-24">
      <ScienceBackground />
      <Navbar />

      <div className="relative z-10 pt-20 pb-16 px-6 text-center w-full max-w-4xl mx-auto">
        <div className="inline-block px-4 py-1.5 rounded-full bg-orange-100 text-orange-600 font-bold text-sm tracking-wide mb-6 border border-orange-200 shadow-sm">
          Usage Guidelines 📋
        </div>
        <h1 className="text-4xl md:text-6xl font-black uppercase tracking-tight text-slate-800 mb-6 drop-shadow-sm font-sans">
          TERMS OF <span className="text-orange-600">SERVICE</span>
        </h1>
        <p className="text-lg text-slate-500 font-medium max-w-2xl mx-auto leading-relaxed">
          Please read these terms carefully before using the Kasun Walakumbura Education Center platform.
        </p>
      </div>

      <div className="relative z-10 flex-grow px-6 md:px-12 pb-24 max-w-4xl mx-auto w-full">
        <div className="bg-white/80 backdrop-blur-xl border border-white p-8 md:p-12 rounded-[2.5rem] shadow-2xl space-y-12">
          
          <TermSection 
            icon={<FaFileSignature className="text-orange-500" />}
            title="Agreement to Terms"
            content="By accessing or using our website and educational services, you agree to be bound by these Terms of Service. If you do not agree with any part of these terms, you may not access our services."
          />

          <TermSection 
            icon={<FaUserGraduate className="text-blue-500" />}
            title="Student Accounts"
            content="To access most features, you must register for an account. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You must provide accurate and complete information during registration."
          />

          <TermSection 
            icon={<FaMoneyBillWave className="text-green-600" />}
            title="Payments & Refunds"
            content={
              <ul className="space-y-4 list-disc list-inside text-slate-600 font-medium ml-4">
                <li>Course fees must be paid in full to access premium materials and live sessions.</li>
                <li>Monthly enrollments expire at the end of the specified academic month.</li>
                <li>Refunds are processed on a case-by-case basis and must be requested within 7 days of payment.</li>
                <li>We reserve the right to change course pricing with prior notice.</li>
              </ul>
            }
          />

          <TermSection 
            icon={<FaVideo className="text-purple-500" />}
            title="Intellectual Property"
            content="All course content, videos, PDFs, and exam materials provided on this platform are the exclusive property of Kasun Walakumbura Education Center. You are granted a limited license to view these materials for personal educational use only. Recording, downloading, or redistributing our content is strictly prohibited."
          />

          <TermSection 
            icon={<FaBan className="text-red-500" />}
            title="Prohibited Conduct"
            content="Users agree not to engage in any activity that disrupts the platform, including sharing login credentials, using automated systems to scrape data, or posting inappropriate content in discussion forums. Violation of these rules may lead to immediate account termination."
          />

          <TermSection 
            icon={<FaBalanceScale className="text-slate-700" />}
            title="Governing Law"
            content="These terms are governed by and construed in accordance with the laws of Sri Lanka. Any disputes arising from these terms shall be subject to the exclusive jurisdiction of the courts of Sri Lanka."
          />

          <div className="pt-10 border-t border-slate-100 text-center">
            <p className="text-slate-500 font-bold text-sm italic">
              "Dedicated to providing quality science education with integrity."
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

const TermSection = ({ icon, title, content }) => (
  <div className="space-y-4">
    <div className="flex items-center gap-4">
      <div className="w-12 h-12 bg-slate-50 rounded-2xl flex items-center justify-center text-2xl border border-slate-100 shadow-inner">
        {icon}
      </div>
      <h2 className="text-2xl font-black text-slate-800 uppercase tracking-tight">{title}</h2>
    </div>
    <div className="text-slate-600 font-medium leading-relaxed pl-1">
      {content}
    </div>
  </div>
);

export default TermsOfService;
